import { useEffect, useRef, useState } from "react";

function formatNum(n) {
    return n.toLocaleString("en-IN");
}

export default function Counter({ to, suffix = "", duration = 1800, testId }) {
    const [value, setValue] = useState(0);
    const [started, setStarted] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const obs = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !started) {
                    setStarted(true);
                }
            },
            { threshold: 0.4 }
        );
        obs.observe(el);
        return () => obs.disconnect();
    }, [started]);

    useEffect(() => {
        if (!started) return;
        const start = performance.now();
        const target = to;
        let raf;
        const tick = (now) => {
            const elapsed = now - start;
            const t = Math.min(1, elapsed / duration);
            // ease-out cubic for mechanical snap finish
            const eased = 1 - Math.pow(1 - t, 3);
            setValue(Math.floor(eased * target));
            if (t < 1) raf = requestAnimationFrame(tick);
            else setValue(target);
        };
        raf = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf);
    }, [started, to, duration]);

    return (
        <span ref={ref} data-testid={testId} className="tabular-nums">
            {formatNum(value)}
            {suffix}
        </span>
    );
}
